<mat-card class="combined-header-card">
  <mat-card-content>
    <!-- 1. Page Heading -->
    <mat-card-title>
      District of {{ districtName }} Results –
      {{ isFinal ? "Final" : "Provisional" }}
    </mat-card-title>

    <!-- 2. Disclaimer -->
    <p class="disclaimer">
      {{ isFinal ? finalDisclaimer : provisionalDisclaimer }}
    </p>

    <!-- 3. Last Updated -->
    <p class="last-updated">
      Last updated : {{ lastUpdate | date : "dd MMM yyyy HH:mm" }}
    </p>

    <!-- 4. Count Progress (hidden when results are final) -->
    <div *ngIf="countProgress && !isFinal" class="count-progress-section">
      <h2 class="count-progress-heading">Count progress</h2>
      <div>
        <div class="progress-item">
          <mat-progress-bar
            mode="determinate"
            [value]="countProgress.boothsPercent"
          ></mat-progress-bar>
          <span class="info"
            >{{ countProgress.boothsReported }} of
            {{ countProgress.boothsTotal }} polling booths</span
          >
          <span class="info">
            ({{ countProgress.boothsPercent / 100 | percent : "1.1-1" }})</span
          >
        </div>
        <div class="progress-item">
          <mat-progress-bar
            mode="determinate"
            [value]="countProgress.earlyVotingCentresPercent"
          ></mat-progress-bar>
          <span class="info"
            >{{ countProgress.earlyVotingCentresReported }} of
            {{ countProgress.earlyVotingCentresTotal }} early voting
            centres</span
          >
          <span class="info">
            ({{
              countProgress.earlyVotingCentresPercent / 100 | percent : "1.1-1"
            }})</span
          >
        </div>
      </div>
    </div>
  </mat-card-content>
</mat-card>
